import { MockFactory } from '@tino-frontend/mocks'
import { ValidatePaymentLinkResponse } from '@types'

export const validatePaymentLinkInvalidMock =
  new MockFactory<ValidatePaymentLinkResponse>({
    is_valid: false,
    amount_cents: 500,
    merchant_document_number: 'merchant_document_number_1',
  })
